<template>
    <div class="favorite-details">
        <div class="favorite-product">
            <div v-show="!!favorite.product" class="image-container">
                <Media v-if="favorite?.product?.thumbnailImageUrl" :media="favorite.product.thumbnailImageUrl" defaultMediaType="image"/>
            </div>
            <h4 v-show="!!favorite.product">
                {{ favorite?.product?.name }}
            </h4>
            <div v-show="!favorite.product" class="skeleton-img">
            </div>
            <div v-show="!favorite.product" class="skeleton">
                
            </div>

        </div>
        <div class="ctas">
            <RothcoCta ref="product_link" id="product_link" class="primary" :href="favorite?.product?.seo_name ? route('productDetail.show', [favorite?.product?.seo_name]) : '#'">
                View Product
            </RothcoCta>
            <button id="delete_button" 
                class="secondary" 
                @click="removeFavorite()">
                    <DeleteBlackIcon class="secondary" style="margin:0;"/>
            </button>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import Media from "./Media.vue";
    import RothcoCta from "./RothcoCta.vue";
    import productVariantSwatches from "@/helpers/composables/productVariantSwatches.ts";
    import DeleteBlackIcon from "@icons/delete-black.svg";
    let props = defineProps({
        favorite: {
            type: Object,
            default(){
                return {
                    product: {}
                }
            }
        }
    })

    let route = inject("route");

    let { productVariants } = productVariantSwatches();
    let variants = computed(()=>{
        return productVariants(props.favorite.product.variants);
    })

    const emit = defineEmits(["removeFavorite"]);
    const removeFavorite = ()=>{
        emit('removeFavorite', props.favorite.favorite_id)
    }
</script>